module.exports = __webpack_public_path__ + "img/play.9e2115f8.svg";